import { InitialQueryState, SkipOrArgs } from '@common/types/queryState';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import {
    useCollectionAssets,
    UseCollectionAssetsArgs,
} from './useCollectionAssets';
import { useSelectedCollectionId } from './useSelectedCollectionSelectors';

export const useSelectedCollectionAssets = (
    initialArgs: InitialQueryState = {},
) => {
    const collectionId = useSelectedCollectionId();
    const queryArgs: SkipOrArgs<UseCollectionAssetsArgs> = useMemo(() => {
        if (!collectionId) return skipToken;
        return { collectionId };
    }, [collectionId]);

    return useCollectionAssets(initialArgs, queryArgs);
};
